<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.entryId ? (isEdit ? '编辑入库单' : '查看入库单') : '新增入库单'"
    v-bind="$attrs" v-on="$listeners">
    <div class="edit-box flex-c-e" v-if="baseForm.entryId && baseForm.entryStatus === '0'">
      <el-button v-if="mixinHasPermi(['inventory:entry:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child" v-closeSelect>
      <item-box class="base-info">
        <template v-slot:title>入库单基本信息</template>
        <template v-slot:content>
          <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
            :disabled="!!(!isEdit && baseForm.entryId)" label-width="120px">
            <el-form-item v-if="baseForm.entryId" class="half" label="入库单号" prop="entryNo">
              <el-input disabled v-model.trim="dialogForm.entryNo" clearable placeholder="请输入入库单号">
              </el-input>
            </el-form-item>
            <el-form-item class="half" label="入库类型" prop="entryType">
              <el-select-dict dictType="ENTRY_TYPE" @dictChange="handleEntryTypeChange"
                v-model.trim="dialogForm.entryType" clearable placeholder="请选择入库类型" />
            </el-form-item>
            <el-form-item :key="dialogForm.entryType" v-if="['3', '4'].includes(dialogForm.entryType)" class="half"
              label="关联出库单号" prop="outNo">
              <el-input :disabled="spuList.length > 0" v-model.trim="dialogForm.outNo" clearable
                placeholder="请输入关联出库单号">
              </el-input>
            </el-form-item>
            <el-form-item class="half" v-if="dialogForm.entryType !== '1' && (!['3', '4'].includes(dialogForm.entryType) || dialogForm.customerName)"
              :label="['3', '4'].includes(dialogForm.entryType) ? '客户' : '供应商'" prop="customerName">
              <div class="box flex-c-s">
                <el-input disabled readonly v-model.trim="dialogForm.customerName" clearable
                  placeholder="请选择供应商"></el-input>
                <el-button v-if="!['3', '4'].includes(dialogForm.entryType) && dialogForm.entryStatus !== '1'" type="primary" size="mini"
                  class="get-button" @click="showSelectCustomer = true">搜索</el-button>
              </div>
            </el-form-item>
            <el-form-item v-if="!baseForm.entryId || isEdit" class="half" label="入库仓库">
              <el-cascader aria-hidden="false" @change="handleWareHouseChange" :options="wareHouseData" clearable
                :props="defaultProps" v-model="entryWareHouse" :disabled="spuList.length > 0" placeholder="请选择入库仓库" >
                  <template slot-scope="{ node, data }">
                    <div class="warehouse-item flex-c-b">
                      <span>{{ data.wareHouseName }}</span>
                      <span class="flex-shrink flex-c-s" v-if="node.isLeaf && !data.disabled"> (<el-text-dict dictType="CAPACITY_STATUS" :type="mixinJudgeWareHouseTypeFun(data.capacityStatus)">{{data.quantity}}/{{ data.maxQuantity }}</el-text-dict>) </span>
                    </div>
                  </template>
                </el-cascader>
            </el-form-item>
            <el-form-item v-if="baseForm.entryId && !isEdit" class="half" label="总数量" prop="entrySumNumber">
              <el-input disabled v-model.trim="dialogForm.entrySumNumber" clearable placeholder="请输入总数量"></el-input>
            </el-form-item>
            <el-form-item v-if="baseForm.entryId && !isEdit" class="half" label="总成本(元)" prop="entrySumCostPrice">
              <el-input disabled v-model.trim="dialogForm.entrySumCostPrice" clearable
                placeholder="请输入总成本"></el-input>
            </el-form-item>
            <el-form-item v-if="baseForm.entryId" class="half" label="入库状态" prop="entryStatus">
              <el-tag-dict :value="dialogForm.entryStatus" dictType="ENTRY_STATUS"></el-tag-dict>
            </el-form-item>
            <el-form-item class="all" label="备注" prop="remark">
              <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
                placeholder="请输入备注" />
            </el-form-item>
          </el-form>
        </template>
      </item-box>

      <item-box class="base-info">
        <template v-slot:title>商品明细</template>
        <template v-slot:content>
          <div class="btn-box" v-if="!baseForm.entryId || baseForm.entryStatus === '0'">
            <el-button type="primary" size="mini" :disabled="!!(!isEdit && baseForm.entryId)"
              @click="handleAdd">添加商品</el-button>
            <el-button type="danger" size="mini" v-if="!(!isEdit && baseForm.entryId)" :disabled="spuList.length === 0"
              @click="handleClearAll">清空商品</el-button>
          </div>
          <div class="tips flex-c-s" v-if="notAllowWareHouseNum !== 0">总共<el-text-dict style="padding: 0 6px;" type="primary">{{ total }}</el-text-dict>条数据，其中<el-text-dict style="padding: 0 6px;" type="warning">{{ notAllowWareHouseNum }}</el-text-dict>条无权限查看</div>

          <el-table :data="spuList" :row-class-name="getRowClassName">
            <el-table-column align="left" prop="goodsName" label="商品名称" width="128px"></el-table-column>
            <el-table-column align="left" prop="skuListStr" label="规格" width="128px"></el-table-column>
            <!-- <el-table-column align="center" prop="qualityGuaranteePeriod" label="保质期(天)"
              width="100px"></el-table-column> -->
            <el-table-column align="center" prop="manufactureDate" label="生产日期" width="180px">
              <template slot-scope="scope">
                <el-date-picker class="date-input" :picker-options="pickerOptions" value-format="yyyy-MM-dd"
                  :disabled="!!(!isEdit && baseForm.entryId) || ['3', '4'].includes(dialogForm.entryType)" type="date"
                  v-model="scope.row.manufactureDate" placeholder="请选择生产日期" />
              </template>
            </el-table-column>
            <el-table-column align="center" prop="wareHouseId" label="入库仓库">
              <template slot-scope="scope">
                <el-cascader aria-hidden="false" :options="wareHouseData"
                  disabled v-if="!!(!isEdit && baseForm.entryId) || unSelectWareHouse" clearable :props="otherDefaultProps"
                  v-model="scope.row.wareHouseId" placeholder="请选择入库仓库" />
                <el-cascader aria-hidden="false" v-else :options="wareHouseData"
                  :disabled="!!(!isEdit && baseForm.entryId) || unSelectWareHouse" clearable :props="defaultProps"
                  v-model="scope.row.wareHouseId" placeholder="请选择入库仓库" >
                    <template slot-scope="{ node, data }">
                      <div class="warehouse-item flex-c-b">
                        <span>{{ data.wareHouseName }}</span>
                        <span class="flex-shrink flex-c-s" v-if="node.isLeaf && !data.disabled"> (<el-text-dict dictType="CAPACITY_STATUS" :type="mixinJudgeWareHouseTypeFun(data.capacityStatus)">{{data.quantity}}/{{ data.maxQuantity }}</el-text-dict>) </span>
                      </div>
                    </template>
                  </el-cascader>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="costPrice" label="成本单价(元)" width="160px">
              <template slot-scope="scope">
                <span v-if="!!(!isEdit && baseForm.entryId) || ['3', '4'].includes(dialogForm.entryType)">{{
                  scope.row.costPrice }}</span>
                <el-input v-else @input="handleInput(scope.$index)" @blur="handleBlur(scope.$index)"
                  v-model="scope.row.costPrice" placeholder="请输入成本单价"></el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="['3', '4'].includes(dialogForm.entryType)" align="center" prop="salesPrice" label="销售单价(元)" width="108px">
              <template slot-scope="scope">
                <span>{{ scope.row.salesPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="entryNumber" label="入库数量" width="160px">
              <template slot-scope="scope">
                <el-input-number v-if="!['3', '4'].includes(dialogForm.entryType)" class="number-input"
                  :disabled="!!(!isEdit && baseForm.entryId)" v-model="scope.row.entryNumber"
                  :min="1"></el-input-number>
                <el-input-number v-else class="number-input" :disabled="!!(!isEdit && baseForm.entryId)"
                  v-model="scope.row.entryNumber" :min="1" :max="scope.row.canUsedNumber"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column align="center" v-if="isEdit || baseForm.entryStatus !== '2'" prop="entryNumber" label="操作"
              width="160px">
              <template slot-scope="scope">
                <el-button type="success" v-if="baseForm.entryId && !isEdit && baseForm.entryStatus !== '2'" size="mini"
                  @click="handlePrintOneGoodTag(scope.row)">打印标签</el-button>
                <el-button type="success"
                  v-if="!(!isEdit && baseForm.entryId) && !['3', '4'].includes(dialogForm.entryType)" size="mini"
                  @click="handleCopy(scope.row, scope.$index)">复制</el-button>
                <el-button type="danger" v-if="!(!isEdit && baseForm.entryId)" size="mini"
                  @click="handleDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </item-box>

    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.entryId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="danger" @click="discardEntry" v-hasPermission="['inventory:entry:discard']"
          v-show="baseForm.entryId && !isEdit && baseForm.entryStatus === '0'">作 废</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.entryId || isEdit">保 存</el-button>
        <el-button type="success" @click="printGoodsTag"
          v-show="baseForm.entryId && !isEdit && baseForm.entryStatus !== '2'">打印商品标签</el-button>
        <el-button type="primary" @click="printEntry"
          v-show="baseForm.entryId && !isEdit && baseForm.entryStatus !== '2'">打印入库单</el-button>
        <el-button type="primary" @click="confirmEntry"
          v-show="baseForm.entryId && !isEdit && baseForm.entryStatus === '0'">确认入库</el-button>
      </template>
    </div>
    <select-spu ref="selectSpu" title="选择商品" width="1280px" :modal="true" :visible.sync="showSelectSpu"
      :selectIdArr="selectIdArr" @success="handleSuccess" @close="showSelectSpu = false" :modal-append-to-body="true"
      :append-to-body="true" :close-on-click-modal="false" />

    <select-out-spu ref="selectOutSpu" :outNo="resultOutNo" :title="outTitle" width="1280px" :modal="true"
      :visible.sync="showSelectOutSpu" :entryType="dialogForm.entryType" :selectIdArr="selectIdArr"
      @success="handleOutSpuSuccess" @close="showSelectOutSpu = false" :modal-append-to-body="true"
      :append-to-body="true" :close-on-click-modal="false" />

    <goods-tag v-if="baseForm.entryId && baseForm.entryStatus !== '2'" ref="goodsTag" :spuList="spuList"></goods-tag>
    <goods-tag-one v-if="baseForm.entryId && baseForm.entryStatus !== '2'" ref="goodsTagOne"></goods-tag-one>

    <entry-print v-if="baseForm.entryId && baseForm.entryStatus !== '2'" ref="entryNoRef" :spuList="spuList"
      :entryData="dialogForm" :wareHouseData="wareHouseData"></entry-print>

    <select-customer ref="selectCustomer" customerType="2" title="选择供应商" width="1000px" :modal="true" :visible.sync="showSelectCustomer"
      @handleSelect="handleSelectCustomer" @close="showSelectCustomer = false" :modal-append-to-body="true"
      :append-to-body="true" :close-on-click-modal="false" />
  </el-dialog>
</template>
<script>
import { entryApi } from "@/api"
import SelectSpu from "./select-spu.vue"
import SelectOutSpu from "./select-out-spu.vue"
import GoodsTag from "./goods-tag.vue"
import GoodsTagOne from "./goods-tag-one.vue"
import EntryPrint from "./entry-print.vue"
import SelectCustomer from "@/components/select-customer/index.vue"
import {formatDate} from "vue2-element-dict"
export default {
  name: "EntryDialog",
  components: { SelectSpu, SelectOutSpu, GoodsTag, EntryPrint, GoodsTagOne, SelectCustomer },
  props: {
    wareHouseData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    //入库单数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    // 校验关联出库单号是否正确
    const checkOutNo = (rule, value, callback) => {
      this.isCheckingOutNo = true
      if (!this.hasClickAdd) {
        this.$Loading.show()
      }
      entryApi
        .checkOutNo({ outNo: value, entryType: this.dialogForm.entryType })
        .then((data) => {
          if (data.validateResult) {
            // 通过关联出库单号获取 客户信息
            this.getCustomerDataByOutNo(value)
            this.resultOutNo = value
            this.isCheckingOutNo = false
            callback()
          } else {
            this.resultOutNo = ""
            this.isCheckingOutNo = false
            this.hasClickAdd = false
            this.$Loading.hide()
            callback(data.msg)
          }
        }).catch(() => {
          this.resultOutNo = ""
          this.isCheckingOutNo = false
          this.hasClickAdd = false
          this.$Loading.hide()
          callback()
        })
    }
    return {
      // 解决输入完 出库单号后 尚未失去焦点时  点击添加商品 的问题
      hasClickAdd: false, // 检查期间是否有点击新增商品
      isCheckingOutNo: false, // 是否正在检查出库单号
      notAllowWareHouseNum: 0, // 无权限查看的数据条数
      total: 0, // 该入库单 商品条数
      resultOutNo: "", // 正确的出库单号
      showSelectCustomer: false, // 选择供应商
      outTitle: "选择商品",
      unSelectWareHouse: false,
      entryWareHouse: [], // 入库仓库
      entryWareHouseId: "",
      pickerOptions: {
        disabledDate: (date) => {
          // 大于今天的日期禁用
          const now = new Date().getTime()
          if (date.getTime() > now) {
            return true
          }
          return false
        }
      },
      allWareHouseIds: [], // 所有仓库id列表
      otherDefaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      defaultProps: {
        checkStrictly: false,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      showSelectOutSpu: false, // 出库商品中选择商品
      showSelectSpu: false,
      selectIdArr: [],
      spuList: [],
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        entryType: [
          {
            required: true,
            message: "请选择入库单类型",
            trigger: ["blur", "change"]
          }
        ],
        outNo: [
          {
            required: true,
            message: "请输入关联出库单号",
            trigger: "blur"
          },
          { validator: checkOutNo, trigger: "blur" }
        ],
        customerName: [
          {
            required: true,
            message: "请选择供应商",
            trigger: "change"
          }
        ]
      }
    }
  },
  watch: {
    showSelectCustomer(val) {
      if (!val) {
        // 关闭前调整遮罩层
        this.mixinRemoveAndAddMask()

        // 重置表单
        this.$refs.selectCustomer.resetQuery()
      }
    },
    showSelectOutSpu(val) {
      if (!val) {
        this.$refs.selectOutSpu.clearSelection()
        // 关闭前调整遮罩层
        this.mixinRemoveAndAddMask()
      }
    },
    showSelectSpu(val) {
      if (!val) {
        this.$refs.selectSpu.clearSelection()
        // 关闭前调整遮罩层
        this.mixinRemoveAndAddMask()
      }
    },
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = val ? JSON.parse(JSON.stringify(val)) : {}
        if (this.dialogForm.customer) {
          this.dialogForm.customerName = this.dialogForm.customer?.customerName
        }
        // 渲染已选择的 商品列表
        this.renderSpuList()
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    // 获取所有仓库id列表
    this.getAllWareHouseIds()
  },
  methods: {
    // 清空所有入库商品
    handleClearAll() {
      const _this = this
      this.$modal.confirm("确认清空所有入库商品吗？", {
        beforeClose: (action, instance, done) => {
          // 关闭前调整遮罩层
          _this.mixinRemoveAndAddMask()
          done()
        }
      }).then(() => {
        _this.spuList = []
      })
    },
    // 选择供应商
    handleSelectCustomer(row) {
      this.showSelectCustomer = false

      // 关闭前调整遮罩层
      this.mixinRemoveAndAddMask()

      this.$set(this.dialogForm, "customerId", row.customerId)
      this.$set(this.dialogForm, "customerName", row.customerName)
      this.$nextTick(() => {
        this.$refs.dialogFormRef.validateField("customerName")
      })
    },
    // 通过出库单号获取 客户信息
    getCustomerDataByOutNo(outNo) {
      entryApi
        .getCustomerDataByOutNo({ outNo })
        .then((data) => {
          this.$set(this.dialogForm, "customerId", data.customerId)
          this.$set(this.dialogForm, "customerName", data.customerName)
          if (this.hasClickAdd) { // 检查期间有触发，则重新点击添加
            this.hasClickAdd = false
            this.handleAdd()
          }
          this.$Loading.hide()
        }).catch(() => {
          this.hasClickAdd = false
          this.$Loading.hide()
        })
    },
    // 失去焦点事件
    handleBlur(index) {
      // 若输入值不为空
      if (this.spuList[index]["costPrice"]) {
        // 将输入值转换为浮点数
        const num = parseFloat(this.spuList[index]["costPrice"])
        // 判断是否为有效的数字
        if (!isNaN(num)) {
          // 保留两位小数
          this.spuList[index]["costPrice"] = num.toFixed(2)
        }
      } else {
        this.spuList[index]["costPrice"] = "0.00"
      }
    },
    // 输入事件
    handleInput(index) {
      let value = this.spuList[index]["costPrice"]
      // 移除非数字和小数点的字符
      value = value.replace(/[^\d.]/g, "")
      // 处理多个小数点的情况
      const parts = value.split(".")
      if (parts.length > 2) {
        value = parts[0] + "." + parts[1]
      }
      // 保留最多两位小数
      const match = value.match(/^\d+(\.\d{0,2})?/)
      if (match) {
        this.spuList[index]["costPrice"] = match[0]
      } else {
        this.spuList[index]["costPrice"] = ""
      }
    },
    //  入库仓库改变事件  
    handleWareHouseChange(val) {
      this.entryWareHouseId = val[val.length - 1] || ""
      if (this.entryWareHouseId) { // 统一仓库 则底下 仓库不让选择
        this.unSelectWareHouse = true
      } else {
        this.unSelectWareHouse = false
      }
    },
    // 入库类型改变事件
    handleEntryTypeChange(val) {
      // 改变入库类型 得 清空 已选择的商品列表
      this.spuList = []

      this.dialogForm.customerId = ""
      this.dialogForm.customerName = ""

      if (["3", "4"].includes(val)) {
        if (this.dialogForm.outNo) {
          this.$nextTick(() => {
            this.$refs.dialogFormRef.validateField("outNo")
          })
        }
      } else {
        this.dialogForm.outNo = ""
        if (val === "1") {
          this.dialogForm.customerId = 1
          this.dialogForm.customerName = "我"
        } else {
          this.$nextTick(() => {
            this.$refs.dialogFormRef.clearValidate("customerName")
          })
        }
      }
    },
    // 打印单个商品标签
    handlePrintOneGoodTag(data) {
      this.$nextTick(() => {
        this.$refs.goodsTagOne && this.$refs.goodsTagOne.print(data)
      })
    },
    // 给表格行添加 类
    getRowClassName({ row, rowIndex }) {
      return row.hasError ? "error" : ""
    },
    getAllWareHouseIds() {
      entryApi.getAllWareHouseIds().then(data => {
        this.allWareHouseIds = data
      })
    },
    // 作废
    discardEntry() {
      const _this = this
      _this.$modal
        .confirm('是否确认作废入库单号为"' + _this.dialogForm.entryNo + '"的数据项？')
        .then(function() {
          return entryApi.discardEntry({ entryId: _this.dialogForm.entryId })
        })
        .then(() => {
          _this.$modal.msgSuccess("入库单作废成功")
          _this.$emit("close")
          _this.$emit("successs")
        }).finally((err) => {
          // 关闭前调整遮罩层
          this.mixinRemoveAndAddMask()
        })
    },
    // 确认入库
    confirmEntry() {
      entryApi.confirmEntry({ entryId: this.dialogForm.entryId }).then(() => {
        this.$modal.msgSuccess("入库单确认成功")
        // 刷新角标
        this.$store.dispatch("user/getUserInfo")
        this.$emit("close")
        this.$emit("successs")
      })
    },
    // 打印入库单
    printEntry() {
      this.$nextTick(() => {
        this.$refs.entryNoRef && this.$refs.entryNoRef.print()
      })
    },
    // 打印商品标签
    printGoodsTag() {
      this.$nextTick(() => {
        this.$refs.goodsTag && this.$refs.goodsTag.print()
      })
    },
    // 渲染已选择的 商品列表
    renderSpuList() {
      // 如果已入库 列表数据 从入库表中获取
      if (this.baseForm.entryId && this.baseForm.entryStatus === "1") {
        entryApi.getEntryDetail({ entryId: this.baseForm?.entryId }).then(data => {
          this.spuList = data.rows || []
          this.total = data.total || 0
          this.notAllowWareHouseNum = data.notAllowWareHouseNum || 0
        })
        return
      }

      const spuIdArr = []
      const spuList = []
      const list = this.baseForm.spuListJson ? JSON.parse(this.baseForm.spuListJson) : []
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        const wareHouseId = (Array.isArray(item.wareHouseId) ? item.wareHouseId[item.wareHouseId.length - 1] : item.wareHouseId) || null
        if (!this.mixinPermiWareHouseIds.includes(wareHouseId)) {
          spuList.push({ ...item, hasError: true })
        } else {
          spuList.push({ ...item, hasError: false })
        }
        spuIdArr.push(item.spuId)
      }

      this.spuList = spuList

      // 去重一下
      this.selectIdArr = [... new Set(spuIdArr)]
    },
    // 复制
    handleCopy(row, index) {
      const newRow = JSON.parse(JSON.stringify(row))
      // 插入到当前行的下方
      this.spuList.splice(index + 1, 0, {
        ...newRow,
        manufactureDate: "",
        wareHouseId: this.entryWareHouseId,
        entryNumber: ""
      })
    },
    // 删除
    handleDelete(index) {
      this.spuList.splice(index, 1)
    },
    // 点击新增
    handleAdd() {
      this.mixinBtnBlur()
      if (this.isCheckingOutNo) {
        this.hasClickAdd = true // 在检查期间有点击添加商品
        this.$Loading.show()
        return
      }

      if (!this.dialogForm.entryType) {
        this.$modal.msgWarning("请选择入库单类型")
        return
      }

      if (this.dialogForm.entryType === "3" || this.dialogForm.entryType === "4") { // 退货入库 或 归还入库 从销售出库 或 外借出库中查找商品
        if (!this.dialogForm.outNo) {
          this.$modal.msgWarning("退货入库或归还入库时，请输入关联出库单号以便查找对应商品。")
          return
        }
        if (!this.resultOutNo) {
          this.$modal.msgWarning("请输入正确的关联出库单号")
          return
        }
        const selectIdArr = this.spuList.map(item => { return item.outSpuId })
        // 去重
        this.selectIdArr = [...new Set(selectIdArr)]

        this.outTitle = `选择商品（${this.dialogForm.outNo}）`
        this.showSelectOutSpu = true
      } else {
        const selectIdArr = this.spuList.map(item => { return item.spuId })
        // 去重
        this.selectIdArr = [...new Set(selectIdArr)]
        this.showSelectSpu = true
      }
    },
    handleOutSpuSuccess(spuList) {
      this.showSelectOutSpu = false

      const list = []
      for (let i = 0; i < spuList.length; i++) {
        const item = spuList[i]
        // 旧的列表中是否存在
        const oldItem = this.spuList.find(childItem => { return childItem.outSpuId === item.outSpuId })
        if (oldItem) {
          list.push(oldItem)
        } else {
          list.push({
            ...item,
            wareHouseId: this.entryWareHouseId,
            entryNumber: item.canUsedNumber,
            hasError: false // 是否有错误
          })
        }
      }
      this.spuList = list
    },
    // 选择好添加的单品  添加removeIds 为了解决  复制的商品 填好信息后 如果单纯遍历的话 数据会变 因此 改为原数据 不懂 删除掉 被删除的数据 再插入
    handleSuccess(spuList, removeIds) {
      this.showSelectSpu = false
      // 先过滤掉 没被选中的列表  且没被移除的
      this.spuList = this.spuList.filter(item => {
        return this.selectIdArr.includes(item.spuId) && !removeIds.includes(item.spuId)
      })

      // 列表中没有 被选中的，就添加进去
      spuList.forEach(item => {
        if (!this.spuList.some(item2 => item2.spuId === item.spuId)) {
          const obj = {
            ...item,
            manufactureDate: formatDate(new Date(), "yyyy-MM-dd"),
            wareHouseId: this.entryWareHouseId,
            entryNumber: "",
            hasError: false // 是否有错误
          }
          this.spuList.push(obj)
        }
      })

      // 根据 goodsName 排序
      this.spuList.sort((a, b) => {
        if (a.goodsName < b.goodsName) { return -1 }
        if (a.goodsName > b.goodsName) { return 1 }
        return 0
      })
    },
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
      if (this.dialogForm.customer) {
        this.dialogForm.customerName = this.dialogForm.customer?.customerName
      }
      // 渲染已选择的 商品列表
      this.renderSpuList()
    },
    // 重置表单
    resetForm() {
      this.unSelectWareHouse = false
      this.entryWareHouse = [] // 入库仓库
      this.entryWareHouseId = ""

      this.notAllowWareHouseNum = 0 // 无权限查看的数据条数
      this.total = 0 // 该入库单 商品条数

      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef && this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate(async valid => {
        if (valid) {
          if (this.spuList.length === 0) {
            this.$modal.msgError("请选择入库商品")
            return
          }

          const selectIdArr = this.spuList.map(item => { return item.spuId })

          const spuIdList = await entryApi.getExistingSpuIds({ spuIds: selectIdArr.join(",") })
          // 判断是否重复（单品id 生产日期 仓库id） 的单品 数据
          const seenCombinations = new Set()
          for (let i = 0; i < this.spuList.length; i++) {
            const item = this.spuList[i]
            item.hasError = false
            const wareHouseId = Array.isArray(item.wareHouseId) ? item.wareHouseId[item.wareHouseId.length - 1] : item.wareHouseId
            if (!item.manufactureDate || !item.entryNumber || !wareHouseId) {
              // 抛异常 跑中间件错误的逻辑
              this.$modal.msgError("请将单品信息填写完整")
              item.hasError = true
              return
            }

            // 生产日期不得大于当前日期
            if (new Date(`${item.manufactureDate} 00:00:00`).getTime() > new Date().getTime()) {
              // 抛异常 跑中间件错误的逻辑
              this.$modal.msgError(`商品名称为【${item.goodsName}】规格为【${item.skuListStr}】的单品生产日期不能大于当前日期！`)
              item.hasError = true
              return
            }

            // 过期的商品 不可入库  
            if ((new Date(`${item.manufactureDate} 00:00:00`).getTime() + (Number(item.qualityGuaranteePeriod) + 1) * 24 * 3600 * 1000) < new Date().getTime()) {
              // 抛异常 跑中间件错误的逻辑
              this.$modal.msgError(`商品名称为【${item.goodsName}】规格为【${item.skuListStr}】的单品已过期，禁止入库！`)
              item.hasError = true
              return
            }

            if (!spuIdList.includes(item.spuId)) {
              this.$modal.msgError(`商品名称为【${item.goodsName}】规格为【${item.skuListStr}】的单品已不存在，请删除！`)
              item.hasError = true
              return
            }
            if (!this.allWareHouseIds.includes(wareHouseId)) {
              this.$modal.msgError(`商品名称为【${item.goodsName}】规格为【${item.skuListStr}】的单品中，请选择入库仓库！`)
              item.hasError = true
              return
            }
            const combination = `${item.spuId}-${item.manufactureDate}-${wareHouseId}`
            if (seenCombinations.has(combination)) {
              this.$modal.msgError(`商品名称为【${item.goodsName}】规格为【${item.skuListStr}】的单品存在生产日期和仓库一样的数据！`)
              item.hasError = true
              return
            }
            seenCombinations.add(combination)
          }

          this.dialogForm.spuList = this.spuList
          //更新
          if (this.dialogForm.entryId) {
            entryApi.updateItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑入库单成功")
              this.$emit("close")
              this.$emit("successs")
              this.spuList = []
            })
          } else {
            //新增
            entryApi.createItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增入库单成功")
              this.$emit("close")
              this.$emit("successs")
              this.spuList = []
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .item-box {
  .item-content-box {
    .el-table {
      .el-table__row {
        &.error {
          position: relative;

          &::after {
            content: "";
            pointer-events: none;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            position: absolute;
            top: 1px;
            left: 1px;
            border: 1px solid red;
            border-radius: 4px;
          }
        }
      }
    }
  }
}

.el-dialog__body {
  .date-input {
    width: 160px;
  }

  .number-input {
    width: 136px;
  }

  .get-button {
    position: absolute;
    width: 88px;
    right: 4px;
    top: 50%;
    transform: translateY(calc(-50% + 2px));
  }
}
</style>